/**
 * New validation rules (for Vuetify's validation system).
 */

import i18n from './plugins/i18n'
import type { VInputRule } from './types/vuetify'

const t = i18n.global.t

export function required(message: string|null = null): VInputRule {
  message = message ?? t('validations.required')
  return (value: any) => !isEmpty(value) || message
}

export function requiredIf(isRequiredFn: Function, message: string|null = null): VInputRule {
  message = message ?? t('validations.required')
  return (value: any) => {
    if (!isRequiredFn()) {
      return true
    }
    return !isEmpty(value) || message
  }
}

export function dollarAmount(message: string|null = null): VInputRule {
  message = message ?? t('validations.dollar_amount')
  return (value: any) => (isEmpty(value) || /^[-]?\d*(\.\d{1,2})?$/.test(value)) || message
}

export function integer(message: string|null = null): VInputRule {
  message = message ?? t('validations.integer')
  return (value: any) => {
    return (isEmpty(value) || Number.isInteger(value)) || message
  }
}

export function minValue(min: number, message: string|null = null): VInputRule {
  message = message ?? t('validations.minValue', {min: min})
  return (value: any) => (isEmpty(value) || value >= min) || message
}

export function maxValue(max: number, message: string|null = null): VInputRule {
  message = message ?? t('validations.maxValue', {max: max})
  return (value: any) => (isEmpty(value) || value <= max) || message
}

export function positive(message: string|null = null): VInputRule {
  message = message ?? t('validations.positive')
  return (value: any) => (isEmpty(value) || value > 0) || message
}


/**
 * Helper functions
 */

export function isEmpty(value: any): boolean {
  return value === null || value === '' || value === undefined || (Array.isArray(value) && !value.length)
}
